export default __webpack_public_path__ + "12a47ed5fd5585f0f4227fa035a1a607.woff2";